/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TutorAIDashboardReportViewModel } from "../types/TutorAIDashboardReportViewModel.ts";
import { dashboardDailyMessagesViewModelSchema } from "./dashboardDailyMessagesViewModelSchema.ts";
import { dashboardDailyTokensViewModelSchema } from "./dashboardDailyTokensViewModelSchema.ts";

export const tutorAIDashboardReportViewModelSchema = z.object({
  periodStart: z
    .string()
    .describe("Data de início do período analisado (formato yyyy-MM-dd).")
    .nullish(),
  periodEnd: z
    .string()
    .describe("Data de fim do período analisado (formato yyyy-MM-dd).")
    .nullish(),
  classStudentId: z
    .number()
    .int()
    .describe("ID da turma filtrada. Opcional.")
    .nullish(),
  totalTokensUsed: z.optional(
    z.number().int().describe("Total de tokens consumidos no período."),
  ),
  tokensPerStudent: z.optional(
    z.number().describe("Média de tokens consumidos por aluno no período."),
  ),
  tokensPerConversation: z.optional(
    z.number().describe("Média de tokens consumidos por conversa no período."),
  ),
  totalConversations: z.optional(
    z.number().int().describe("Total de conversas iniciadas no período."),
  ),
  totalMessages: z.optional(
    z
      .number()
      .int()
      .describe(
        "Total de mensagens trocadas entre alunos e o assistente no período.",
      ),
  ),
  totalStudentsWithConversations: z.optional(
    z
      .number()
      .int()
      .describe(
        "Total de alunos distintos que iniciaram ao menos uma conversa no período.",
      ),
  ),
  dailyTokensEvolution: z
    .array(z.lazy(() => dashboardDailyTokensViewModelSchema))
    .describe(
      "Série temporal diária de tokens consumidos no período. Um item por dia com ao menos um token registrado — dias sem consumo são omitidos. Ordenado por data crescente. Útil para gráficos de linha de custo.",
    )
    .nullish(),
  dailyMessagesEvolution: z
    .array(z.lazy(() => dashboardDailyMessagesViewModelSchema))
    .describe(
      "Série temporal diária de mensagens trocadas no período. Um item por dia com ao menos uma mensagem — dias sem atividade são omitidos. Ordenado por data crescente. Útil para gráficos de linha de engajamento.",
    )
    .nullish(),
}) as unknown as ToZod<TutorAIDashboardReportViewModel>;
